// extracted by mini-css-extract-plugin
export default {"error":"Authorize_error__yGenp"};